import SearchHelper from "../helpers/SearchHelper";
import { TenorGif } from "../types";
import Api from "./Api";

class GifsController extends Api {
  static getGifs(
    query?: string,
    next?: string
  ): Promise<{
    next: string;
    results: TenorGif[];
  }> {
    return fetch(
      `/api/gifs?${SearchHelper.getQueryString({ query: query, next: next })}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }
}

export default GifsController;
